import React from "react";
import { PRICING } from "../mock/mock";
import { useBooking } from "../context/BookingContext";

export default function Pricing() {
  const { openBook } = useBooking();
  return (
    <section id="pricing" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="reveal text-center max-w-2xl mx-auto mb-14">
          <p className="section-line text-gold mb-4">Price List</p>
          <h2 className="font-display text-4xl md:text-5xl font-medium leading-tight">
            Our complete <span className="gold-gradient-text italic">menu & pricing.</span>
          </h2>
          <p className="mt-4 text-cream/60">Every service and sub-service, delivered with expert precision and luxury care.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {PRICING.map((cat, i) => (
            <div
              key={cat.cat}
              className="reveal p-7 md:p-8 rounded-[28px] border hairline bg-viimii-2"
              style={{ transitionDelay: `${(i % 2) * 60}ms` }}
            >
              <h3 className="font-display text-2xl md:text-[26px] gold-gradient-text mb-6">{cat.cat}</h3>

              <div className="space-y-6">
                {cat.groups.map((g) => (
                  <div key={g.sub}>
                    <div className="flex items-baseline gap-3 mb-3">
                      <span className="text-[13px] tracking-[0.14em] uppercase text-cream/90 font-medium" style={{ color: "var(--viimii-clay)" }}>
                        {g.sub}
                      </span>
                      <span className="flex-1 h-px" style={{ background: "rgba(74,58,44,0.12)" }} />
                    </div>
                    {g.desc && <p className="text-xs text-cream/50 italic -mt-1 mb-3">{g.desc}</p>}
                    <ul className="space-y-2.5">
                      {g.items.map(([name, price]) => (
                        <li key={name} className="flex items-baseline justify-between gap-3">
                          <span className="text-sm text-cream/75">{name}</span>
                          <span className="flex-1 border-b border-dashed hairline mx-1 translate-y-[-3px]" />
                          <span className="font-display text-gold-soft whitespace-nowrap" style={{ color: "var(--viimii-gold)" }}>{price}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>

              {cat.note && (
                <p className="text-xs text-cream/45 mt-6 pt-4 border-t hairline">* {cat.note}</p>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-14">
          <button
            onClick={openBook}
            className="inline-flex items-center gap-2 bg-gold text-black font-medium px-8 py-4 rounded-full hover:opacity-90 transition-opacity"
            style={{ background: "var(--viimii-gold)" }}
          >
            Book Your Appointment ✦
          </button>
        </div>
      </div>
    </section>
  );
}
